import React, { useContext, useState, useMemo } from "react";
import "../scss/header.css";
import Logo from "../images/header/Logo Trato.svg";
import Avatar from "./Avatar";
import { useProfile } from "../api/hooks/profile";
import HeaderMenu from "./dashboard/headerMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faEllipsisV } from "@fortawesome/free-solid-svg-icons";

function Header() {
  const { profile, can } = useProfile();
  const [isOpen, setIsOpen] = useState(false);
  const hasProfileImage = useMemo(() => {
    return profile?.office?.logo && profile?.office?.logo !== ""
  }, [profile])
  return (
    <header className="header">
      <img src={Logo} alt="Logo" />
      <div
        className="header__avatar__name"
        style={{ position: "relative", cursor: "pointer" }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <p>
          {profile.givenName} {profile.familyName}
        </p>
        {hasProfileImage ? (
          <div
            className="UploadedImage__dashboardSettings"
            style={{
              backgroundImage: `url(${profile?.office?.logo})`,
            }}
          ></div>
        ) : (
          !hasProfileImage && (
            <Avatar
              className="bg-accent-100  header__avatar ml-3"
              name={profile.givenName}
              lastName={profile.familyName}
              // onClick={toggleProfileMenu}
            />
          )
        )}
        <span style={{ marginLeft: "10px" }}>
          <FontAwesomeIcon icon={faEllipsisV} color="#ffffff" />
        </span>
        {isOpen && <HeaderMenu />}
      </div>
    </header>
  );
}

export default Header;
